import { FileText } from 'lucide-react'
import { publishedHostAnalyticsTerms } from '../lib/hostAnalyticsTerms'

const TERMS_VERSION = 'host-analytics-v1'

export function TermsDocument({ text }: { text: string }) {
  return (
    <article className="mx-auto max-w-3xl space-y-4 py-10 text-foreground">
      {text
        .trim()
        .split(/\n\s*\n/)
        .map((block, index) => {
          if (block.startsWith('# ')) {
            return (
              <h1 key={index} className="text-3xl font-bold tracking-tight">
                {block.slice(2)}
              </h1>
            )
          }
          if (block.startsWith('## ')) {
            return (
              <h2 key={index} className="pt-4 text-xl font-semibold">
                {block.slice(3)}
              </h2>
            )
          }
          if (block.startsWith('- ')) {
            const items: string[] = []
            for (const line of block.split('\n')) {
              if (line.startsWith('- ')) {
                items.push(line.slice(2))
              } else if (items.length > 0) {
                items[items.length - 1] += ` ${line.trim()}`
              }
            }
            return (
              <ul key={index} className="list-disc space-y-2 pl-6">
                {items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )
          }
          return (
            <p key={index} className="leading-7 text-muted-foreground">
              {block.replaceAll('\n', ' ')}
            </p>
          )
        })}
    </article>
  )
}

export function HostAnalyticsTermsPage() {
  const terms = publishedHostAnalyticsTerms(TERMS_VERSION)
  if (!terms) return null
  return (
    <main
      className="min-h-screen bg-background px-6"
      data-testid="analytics-terms"
    >
      <div className="mx-auto flex max-w-3xl items-center gap-2 border-b py-4 text-sm text-muted-foreground">
        <FileText className="size-4" />
        Archigma · {terms.version}
      </div>
      <TermsDocument text={terms.text} />
    </main>
  )
}
